// extracted by mini-css-extract-plugin
export default {"main":"ResetPassword_main__d9Tiu"};